import { Box, Card, CardBody, Center, Flex, Heading, Image, SimpleGrid, Stack, Text, useBreakpointValue } from '@chakra-ui/react';


const Feature = ({ title, text, icon }) => {
    return (
        <Stack>
            <Center>
                <Image boxSize='200px' src={icon} alt='Dan Abramov' />
            </Center>
            <Center>
                <Text fontWeight={600}>{title}</Text>
            </Center>
            <Center>
                <Text color={'gray.600'}>{text}</Text>
            </Center>
        </Stack>
    );
};

export default function WeServe() {
    return (
        <Stack align="center" mb="100px" px={{ base: "14px", sm: "10vw" }} >
            <Box maxW="1140px">
                <Flex p={8} flex={1} align={'center'} justify={'center'} fontWeight="300" color="#1C3E64">
                    <Heading fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}>
                        <Text
                            fontSize="41px"
                            fontWeight="300"
                            pb="8px"
                            borderBottom="1px solid rgba(28, 62, 100, 0.50)"

                        >
                            Investors We Serve
                        </Text>
                        <br />{' '}
                    </Heading>
                </Flex>
                <Center>
                    <SimpleGrid columns={{ base: 1, lg: 2,xl:3 }} spacing={100}>
                        <Card className='zoom' py="24px" borderRadius="20px" border="1px solid #F0F0F0" boxShadow="lg" w="333px">
                            <CardBody >
                                <Center>
                                    <Image
                                        className='zoom'
                                        boxSize='100px'
                                        objectFit='cover'
                                        style={{ mixBlendMode: 'multiply' }}
                                        src='https://redswan.io/wp-content/uploads/2023/03/invstors9-03.jpg'
                                        alt='Individual Investors'
                                        borderRadius='50px'
                                    />
                                </Center>
                                <Center>
                                    <Stack mt='6' spacing='3'>
                                        <Heading fontFamily="Raleway" fontWeight="400" fontSize="27px" color="#1C3E64">Individual Investors</Heading>
                                    </Stack>
                                </Center>
                            </CardBody>
                        </Card>
                        <Card className='zoom' py="24px" borderRadius="20px" border="1px solid #F0F0F0" boxShadow="lg" w="333px" >
                            <CardBody>
                                <Center>
                                    <Image
                                        className='zoom'
                                        style={{ mixBlendMode: 'multiply' }}
                                        boxSize='100px'
                                        objectFit='cover'
                                        src='https://redswan.io/wp-content/uploads/2023/03/invstors4-03.jpg'
                                        alt='Institutional Investors'
                                        borderRadius='50px'
                                    />
                                </Center>
                                <Center>
                                    <Stack mt='6' spacing='3'>
                                        <Heading fontFamily="Raleway" fontWeight="400" fontSize="27px" color="#1C3E64">Institutional Investors</Heading>
                                    </Stack>
                                </Center>
                            </CardBody>
                        </Card>
                        <Card className='zoom' py="24px" borderRadius="20px" border="1px solid #F0F0F0" boxShadow="lg" w="333px">
                            <CardBody>
                                <Center>
                                    <Image
                                        className='zoom'
                                        style={{ mixBlendMode: 'multiply' }}
                                        boxSize='100px'
                                        objectFit='cover'
                                        src='https://redswan.io/wp-content/uploads/2023/03/invstors5-03.jpg'
                                        alt='Family Offices'
                                        borderRadius='50px'
                                    />
                                </Center>
                                <Center>
                                    <Stack mt='6' spacing='3'>
                                        <Heading fontFamily="Raleway" fontWeight="400" fontSize="27px" color="#1C3E64">Family Offices</Heading>
                                    </Stack>
                                </Center>

                            </CardBody>
                        </Card>
                    </SimpleGrid>
                </Center>
                <Flex p={8} flex={1} align={'center'} justify={'center'}>
                    <Heading fontFamily="Raleway" fontWeight="400" fontSize='25px' color="#1C3E64">Many More!</Heading>

                </Flex>
            </Box>
        </Stack>
    );
}